var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkidunLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197.2 42.9",
    style: {
      enableBackground: "new 0 0 197.2 42.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,0c-9.8,0-18.2,7-19.9,16.7l-4.4,24.7h15.7c11.2,0,20.8-8,22.7-19l0.8-4.6C116.8,8.5,109.6,0,100.1,0 L100.1,0z M106,18.3l-0.6,3.4C104.3,27.7,99.1,32,93,32h-6l2.6-15.1c0.8-4.3,4.5-7.4,8.9-7.4C103.2,9.5,106.8,13.7,106,18.3 L106,18.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,41.4l-8.1-15.9c-1.9,1.7-3,3.2-3.5,4.9l-2,11h-9.4L37.7,1h9.5l-2.5,14c0.5-0.3,0.9-0.7,1.4-1 c4.8-3.4,9.3-6.6,10.4-11.5L56.8,1h1.6c2.3,0,4.3,1.2,5.2,3.1c0.8,1.9,0.6,4.1-0.7,6.1c-0.8,1.3-1.9,2.6-3,3.8 c-1.6,1.8-3.7,3.4-6.3,5.4l6.9,13.6c0.9,1.7,0.6,3.9-0.7,5.7c-1.3,1.8-3.3,2.9-5.3,2.9L53.4,41.4L53.4,41.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.7,41.4L69.9,1h1.7c2,0,3.9,0.9,5.1,2.3c1.2,1.4,1.5,3.4,1.2,5.5l-5.8,32.7L62.7,41.4L62.7,41.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.4,42.4c-4.4,0-8.1-1.6-10.6-4.6c-2.3-2.8-3.2-6.5-2.5-10.2L120.9,1h9.5l-4.8,26.8 c-0.2,1.2,0.1,2.5,0.9,3.5c0.9,1.1,2.5,1.8,4.3,1.8c3.9,0,6.9-2.8,7.3-5.4l3.3-19.1c0.7-4.1,4.7-7.5,8.9-7.5h2l-4.7,26.8 c-0.7,3.7-2.9,7.4-6.1,10.1C138,40.8,133.7,42.4,129.4,42.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.4,41.4l-9-21.8l-3.9,21.8H149L156.1,1h4.6c3,0,5.4,1.6,6.5,4.1l7.3,17.8L178.5,1h9.5l-5.7,32.3 c-0.8,4.5-5.3,8.1-9.8,8.1L171.4,41.4L171.4,41.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,1.2C27.2,0.4,23.8,0,20.7,0c-2.3,0-4.1,0.2-5.8,0.8c-2,0.6-3.6,1.4-5.1,2.5C8.3,4.5,7,5.8,6.1,7.3 c-1,1.5-1.7,3.2-2,5c-1.1,6.2,3,9.6,6.7,11.3l6,2.6c3.1,1.4,3.2,3,3,4.1c-0.2,1-0.6,1.6-1.6,2.3c-1,0.7-2.4,1-4,1H14 c-6.2-0.1-10.3-3.9-10.4-4l-0.5-0.5l-1.7,2.4c-1.1,1.5-1.6,3.2-1.3,4.9c0.2,1.7,1.2,3.1,2.7,4c2.2,1.3,5.3,1.9,9.1,1.9 c5.1,0,9.2-1.2,12.2-3.5c3.1-2.4,5-5.5,5.7-9.3c0.5-2.8,0.1-5.2-1.2-7.2c-1.2-1.8-3.1-3.3-6.1-4.7l-4-1.9c0,0-1.9-0.9-3.3-1.6 c-1.4-0.7-2.1-2.6-0.4-4.3c1.2-1.1,3.1-1.4,6.3-1.5c1.2,0,2.4,0.1,3.8,0.3c0.3,0,0.6,0.1,0.9,0.1c3.4,0,6.2-2.5,6.8-5.7l0.3-1.7 L31.6,1.2L31.6,1.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.7,41.4l0.1-0.7c0.8-4.5,4.7-7.8,9.3-7.8h0.9c2.6,0,4.6,2.4,4.2,5c-0.4,2-2.1,3.5-4.2,3.5H182.7L182.7,41.4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkidunLogoBig);
export default __webpack_public_path__ + "static/media/skidun_logo_big.622bcd3749a17d1da16839e2df0a35df.svg";
export { ForwardRef as ReactComponent };